import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CoverImage from './CoverImage';
import { trackEvent } from '../services/analytics';

function ShelfBrowse({ biblioId, currentTitle }) {
  const navigate = useNavigate();
  const [shelf, setShelf] = useState({ callNumber: null, locationName: null, branchName: null, before: [], after: [] });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let ignore = false;

    const fetchShelf = async () => {
      try {
        setLoading(true);
        const response = await fetch(`/api/books/${biblioId}/shelf-neighbors?count=10`);
        if (!response.ok) {
          throw new Error('Failed to fetch shelf neighbors');
        }
        const data = await response.json();
        if (!ignore) {
          setShelf({
            callNumber: data.callNumber || null,
            locationName: data.locationName || null,
            branchName: data.branchName || null,
            before: Array.isArray(data.before) ? data.before : [],
            after: Array.isArray(data.after) ? data.after : [],
          });
        }
      } catch (error) {
        console.error('Error fetching shelf neighbors:', error);
        if (!ignore) {
          setShelf({ callNumber: null, before: [], after: [] });
        }
      } finally {
        if (!ignore) {
          setLoading(false);
        }
      }
    };

    if (biblioId) {
      fetchShelf();
    }

    return () => {
      ignore = true;
    };
  }, [biblioId]);

  const handleOpen = (neighborBook) => {
    trackEvent('shelf_browse_clicked', {
      from: 'book-detail-shelf-browse',
      biblioId: neighborBook.biblio_id,
    });
    navigate(`/book/${neighborBook.biblio_id}`, { state: { from: 'book-detail-shelf-browse' } });
  };

  if (loading) {
    return null;
  }

  if (!shelf.callNumber || (shelf.before.length === 0 && shelf.after.length === 0)) {
    return null;
  }

  return (
    <div className="holdings-section shelf-browse-section">
      <h2>Browse the Shelf</h2>
      <p className="shelf-browse-hint">
        Titles shelved near this one by call number, as if browsing the stacks.
        {(shelf.locationName || shelf.branchName) && (
          <span className="shelf-browse-hint__location">
            {' '}Section: <strong>{[shelf.locationName, shelf.branchName].filter(Boolean).join(' · ')}</strong>
          </span>
        )}
      </p>
      <div className="shelf-browse-track">
        {shelf.before.map((neighbor) => (
          <button
            key={neighbor.biblio_id}
            type="button"
            className="shelf-browse-card"
            onClick={() => handleOpen(neighbor)}
            title={neighbor.title}
          >
            <CoverImage
              biblioId={neighbor.biblio_id}
              isbn={neighbor.isbn}
              alt={neighbor.title}
              className="shelf-browse-card__cover"
              width={70}
              height={104}
              sizeCode="S"
            />
            <span className="shelf-browse-card__call">{neighbor.call_number}</span>
          </button>
        ))}

        <div className="shelf-browse-card shelf-browse-card--current" title={currentTitle}>
          <div className="shelf-browse-card__current-cover">
            <CoverImage
              biblioId={biblioId}
              alt={currentTitle}
              className="shelf-browse-card__cover"
              width={70}
              height={104}
              sizeCode="S"
            />
          </div>
          <span className="shelf-browse-card__call shelf-browse-card__call--current">{shelf.callNumber}</span>
          <span className="shelf-browse-card__current-label">You are here</span>
        </div>

        {shelf.after.map((neighbor) => (
          <button
            key={neighbor.biblio_id}
            type="button"
            className="shelf-browse-card"
            onClick={() => handleOpen(neighbor)}
            title={neighbor.title}
          >
            <CoverImage
              biblioId={neighbor.biblio_id}
              isbn={neighbor.isbn}
              alt={neighbor.title}
              className="shelf-browse-card__cover"
              width={70}
              height={104}
              sizeCode="S"
            />
            <span className="shelf-browse-card__call">{neighbor.call_number}</span>
          </button>
        ))}
      </div>
    </div>
  );
}

export default ShelfBrowse;
